export enum TABS {
  THEME_DETAILS = 'themeDetails',
  CLIPS = 'clips',
  TEXT_OVERLAYS = 'textOverlays'
}
